import { GrooveTypeEnum } from '../../cutting-panel-base-slot.model';
import { PlateTypeEnum } from '../../cutting-panel-outline.model';

export class CountertopSlot {
  id: number;
  sideNumber: number;
  name: string;
  designation: string;
  type: GrooveTypeEnum;
  custom: boolean;
  plate: PlateTypeEnum;
  parameters?:
    | FilletSlotParams
    | ChamferSlotParams
    | Chamfer2SlotParams
    | RabbetSlotParams
    | InPlateSlotParams
    | InSideSlotParams;
}

export class FilletSlotParams {
  r: number;
}

export class ChamferSlotParams {
  fi: number;
}

export class Chamfer2SlotParams {
  dx: number;
  b: number;
}

export class RabbetSlotParams {
  h: number;
  g: number;
}

export class InPlateSlotParams {
  h: number;
  g: number;
  dx: number;
}

export class InSideSlotParams {
  h: number;
  g: number;
  dx: number;
}
